<template>
  <div>
    <!-- <p>След. обновление через: {{ timer }} сек.</p> -->

    <div v-if="user.sections['dashboard-bss']">
      <h4>Статистика контроля</h4>
      <div class="row no-gutters">
        <div class="col-12 col-md-6 col-lg-5 col-xl-3">
          <chart-card
            v-if="subscriptionStatusChart.data.series.length"
            :chart-data="subscriptionStatusChart.data"
            chart-type="Pie"
          >
            <div slot="legend">
              <div class="text-info">
                Всего на контроле: {{ device.control }}
              </div>
              <hr />
              <div class="text-warning">
                Заблокировано: {{ device.blocked }}
              </div>
            </div>
          </chart-card>
        </div>
        <div class="col-12 col-md-6 col-lg-7 col-xl-9">
          <subscription-deptors />
        </div>
      </div>

      <div>
        <h4>Статистика по периодам</h4>

        <div class="filters">
          <div>
            <label>Выберите период</label>
            <select v-model="params['period']" class="form-control">
              <option
                :value="tP.value"
                v-for="(tP, key) in typePeriods"
                :key="key"
              >
                {{ tP.name }}
              </option>
            </select>
          </div>

          <div
            v-show="!params['period']"
            v-for="dFilter in dateFilter"
            :key="dFilter.key"
          >
            <label
              >{{ dFilter.titleKey | setText(dFilter.title) }}
              <span
                v-show="params[dFilter.key]"
                @click="params[dFilter.key] = null"
                class="link"
                >{{ "reset" | setText("сбросить") }}</span
              ></label
            >
            <datetime
              v-model="params[dFilter.key]"
              @input="params['page'] = 1"
              class="from-control"
              type="date"
              format="dd/MM/yyyy"
            ></datetime>
          </div>
        </div>

        <div class="mt-3">
          <export-excel
            :exportFields="exportFields[exportType]"
            :itemLink="'report/subscriptions'"
            :params="params"
          />

          <ul class="status">
            <li>
              <button class="btn btn-icon" @click="exportExcel('all')">
                <span class="ti-upload"></span>
                Общий экспорт
              </button>
            </li>
            <li>
              <button class="btn btn-icon" @click="exportExcel('imei')">
                <span class="ti-upload"></span>
                Экспорт IMEI
              </button>
            </li>
            <li>
              <button class="btn btn-icon" @click="exportExcel('insurance')">
                <span class="ti-upload"></span>
                Экспорт страховка
              </button>
            </li>
          </ul>
        </div>

        <div class="mt-3">
          <h4>Общая статистика</h4>
          <div class="row no-gutters">
            <div
              class="col-md-6 col-lg-4 col-xl-3"
              v-for="stat in stats"
              :key="stat.title"
            >
              <stats-card>
                <div class="numbers-icon" slot="header">
                  <img :src="`/images/features/${stat.icon}`" />
                </div>
                <div class="numbers-text" slot="content" :title="stat.key">
                  <h4>{{ stat.key | setText(stat.title) }}</h4>
                  <p>
                    {{ stat.value | spaceBetweenNumber }}
                    <sup
                      class="badge badge-warning"
                      v-if="stat.conversion != null"
                      >{{ stat.conversion }}%</sup
                    >
                  </p>

                  <div class="badge badge-danger" v-if="stat.warning">
                    {{ stat.warning }}
                  </div>
                </div>
              </stats-card>
            </div>
          </div>
        </div>

        <div class="ratings" v-if="shops.length">
          <h4>Обзор локаций</h4>

          <div class="row no-gutters">
            <div class="col-12 col-md-6">
              <card>
                <h5>ТОП 10</h5>
                <div class="table-full-width table-responsive">
                  <table class="table">
                    <thead>
                      <th>
                        <tr>
                          Магазин
                        </tr>
                      </th>
                      <!-- <th>
                  <tr>
                    Всего запросов по подписке
                  </tr>
                </th> -->
                      <th>
                        <tr>
                          Оформленные подписки
                        </tr>
                      </th>
                      <th>
                        <tr>
                          Сумма
                        </tr>
                      </th>
                      <th>
                        <tr>
                          Тикеты
                        </tr>
                      </th>
                    </thead>
                    <tbody>
                      <tr
                        class="col-12 col-md-4"
                        v-for="(item, k) in shops"
                        :key="k"
                      >
                        <td>{{ k + 1 }}. {{ item.name }}</td>
                        <!-- <td>{{ item.subscriptions_count | spaceBetweenNumber }}</td> -->
                        <td>
                          {{ item.subscriptions_done | spaceBetweenNumber }}
                          <!-- <span class="badge badge-warning"
                      >{{
                        Math.round(
                          item.subscriptions_count
                            ? (item.subscriptions_done /
                                item.subscriptions_count) *
                                100
                            : 0
                        )
                      }}%</span
                    > -->
                        </td>
                        <td>
                          {{
                            item.subscriptions_sum_product_price
                              | spaceBetweenNumber
                          }}
                        </td>
                        <td>
                          {{ item.owner_tickets_count | spaceBetweenNumber }}
                          <span class="badge badge-warning"
                            >{{
                              Math.round(
                                item.subscriptions_count
                                  ? (item.owner_tickets_count /
                                      item.subscriptions_count) *
                                      100
                                  : 0
                              )
                            }}%</span
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </card>
            </div>
            <div class="col-12 col-md-6">
              <card>
                <h5>ФЛОП 10</h5>
                <div class="table-full-width table-responsive">
                  <table class="table">
                    <thead>
                      <th>
                        <tr>
                          Магазин
                        </tr>
                      </th>
                      <!-- <th>
                  <tr>
                    Всего запросов по подписке
                  </tr>
                </th> -->
                      <th>
                        <tr>
                          Оформленные подписки
                        </tr>
                      </th>
                      <th>
                        <tr>
                          Сумма
                        </tr>
                      </th>
                      <th>
                        <tr>
                          Тикеты
                        </tr>
                      </th>
                    </thead>
                    <tbody>
                      <tr
                        class="col-12 col-md-4"
                        v-for="(item, k) in shops_low"
                        :key="k"
                      >
                        <td>{{ k + 1 }}. {{ item.name }}</td>
                        <!-- <td>{{ item.subscriptions_count | spaceBetweenNumber }}</td> -->
                        <td>
                          {{ item.subscriptions_done | spaceBetweenNumber }}
                          <!-- <span class="badge badge-warning"
                      >{{
                        Math.round(
                          item.subscriptions_count
                            ? (item.subscriptions_done /
                                item.subscriptions_count) *
                                100
                            : 0
                        )
                      }}%</span
                    > -->
                        </td>
                        <td>
                          {{
                            item.subscriptions_sum_product_price
                              | spaceBetweenNumber
                          }}
                        </td>
                        <td>
                          {{ item.owner_tickets_count | spaceBetweenNumber }}
                          <span class="badge badge-warning"
                            >{{
                              Math.round(
                                item.subscriptions_count
                                  ? (item.owner_tickets_count /
                                      item.subscriptions_count) *
                                      100
                                  : 0
                              )
                            }}%</span
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </card>
            </div>
          </div>
        </div>

        <div class="ratings" v-if="users.length">
          <h4>Обзор операторов</h4>

          <div class="row no-gutters">
            <div class="col-12 col-md-6">
              <div class="card p-3">
                <h5>ТОП 10</h5>
                <div class="table-full-width table-responsive">
                  <table class="table">
                    <thead>
                      <th>
                        <tr>
                          Оператор
                        </tr>
                      </th>
                      <!-- <th>
                  <tr>
                    Всего запросов по подписке
                  </tr>
                </th> -->
                      <th>
                        <tr>
                          Оформленные подписки
                        </tr>
                      </th>
                      <th>
                        <tr>
                          Сумма
                        </tr>
                      </th>
                      <th>
                        <tr>
                          Тикеты
                        </tr>
                      </th>
                    </thead>
                    <tbody>
                      <tr
                        class="col-12 col-md-4"
                        v-for="(item, k) in users"
                        :key="k"
                      >
                        <td>{{ k + 1 }}. {{ item.name }}</td>
                        <!-- <td>{{ item.subscriptions_count | spaceBetweenNumber }}</td> -->
                        <td>
                          {{ item.subscriptions_done | spaceBetweenNumber }}
                          <!-- <span class="badge badge-warning"
                      >{{
                        Math.round(
                          item.subscriptions_count
                            ? (item.subscriptions_done /
                                item.subscriptions_count) *
                                100
                            : 0
                        )
                      }}%</span
                    > -->
                        </td>
                        <td>
                          {{
                            item.subscriptions_sum_product_price
                              | spaceBetweenNumber
                          }}
                        </td>
                        <td>
                          {{ item.owner_tickets_count | spaceBetweenNumber }}
                          <span class="badge badge-warning"
                            >{{
                              Math.round(
                                item.subscriptions_count
                                  ? (item.owner_tickets_count /
                                      item.subscriptions_count) *
                                      100
                                  : 0
                              )
                            }}%</span
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="card p-3">
                <h5>ФЛОП 10</h5>
                <div class="table-full-width table-responsive">
                  <table class="table">
                    <thead>
                      <th>
                        <tr>
                          Оператор
                        </tr>
                      </th>
                      <!-- <th>
                  <tr>
                    Всего запросов по подписке
                  </tr>
                </th> -->
                      <th>
                        <tr>
                          Оформленные подписки
                        </tr>
                      </th>
                      <th>
                        <tr>
                          Сумма
                        </tr>
                      </th>
                      <th>
                        <tr>
                          Тикеты
                        </tr>
                      </th>
                    </thead>
                    <tbody>
                      <tr
                        class="col-12 col-md-4"
                        v-for="(item, k) in users_low"
                        :key="k"
                      >
                        <td>{{ k + 1 }}. {{ item.name }}</td>
                        <!-- <td>{{ item.subscriptions_count | spaceBetweenNumber }}</td> -->
                        <td>
                          {{ item.subscriptions_done | spaceBetweenNumber }}
                          <!-- <span class="badge badge-warning"
                      >{{
                        Math.round(
                          item.subscriptions_count
                            ? (item.subscriptions_done /
                                item.subscriptions_count) *
                                100
                            : 0
                        )
                      }}%</span
                    > -->
                        </td>
                        <td>
                          {{
                            item.subscriptions_sum_product_price
                              | spaceBetweenNumber
                          }}
                        </td>
                        <td>
                          {{ item.owner_tickets_count | spaceBetweenNumber }}
                          <span class="badge badge-warning"
                            >{{
                              Math.round(
                                item.subscriptions_count
                                  ? (item.owner_tickets_count /
                                      item.subscriptions_count) *
                                      100
                                  : 0
                              )
                            }}%</span
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ratings" v-if="variants.length">
          <h4>Обзор товаров</h4>
          <div class="card p-3">
            <div class="table-full-width table-responsive">
              <table class="table">
                <thead>
                  <th>
                    <tr>
                      Товар
                    </tr>
                  </th>
                  <!-- <th>
                  <tr>
                    Всего запросов по подписке
                  </tr>
                </th> -->
                  <th>
                    <tr>
                      Оформленные подписки
                    </tr>
                  </th>
                  <th>
                    <tr>
                      Сумма
                    </tr>
                  </th>
                </thead>
                <tbody>
                  <tr
                    class="col-12 col-md-4"
                    v-for="(item, k) in variants"
                    :key="k"
                  >
                    <td>{{ k + 1 }}. {{ item.name }}</td>
                    <!-- <td>{{ item.subscriptions_count | spaceBetweenNumber }}</td> -->
                    <td>
                      {{ item.subscriptions_done | spaceBetweenNumber }}
                      <!-- <span class="badge badge-warning"
                      >{{
                        Math.round(
                          item.subscriptions_count
                            ? (item.subscriptions_done /
                                item.subscriptions_count) *
                                100
                            : 0
                        )
                      }}%</span
                    > -->
                    </td>
                    <td>
                      {{
                        item.subscriptions_sum_product_price
                          | spaceBetweenNumber
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { StatsCard, ChartCard } from "@/components/index";
import { errorNotify } from "@/plugins/functions";
import Chartist from "chartist";
import { mapState } from "vuex";

export default {
  components: {
    StatsCard,
    ChartCard,
    "export-excel": () => import("@/components/ExportExcel"),
    "subscription-deptors": () => import("@/pages/SubscriptionDeptors"),
  },
  created() {
    this.loadData();
    // SubscriptionDeptorsoadData();

    setInterval(() => {
      this.timer--;
    }, 1000);
  },
  methods: {
    exportExcel(type) {
      if (!this.exportFields[type]) {
        return false;
      }
      this.exportType = type;
      this.$modal.show("export");
    },
    async loadData(loading = true) {
      if (loading) this.$loading(true);

      if (this.user.sections["dashboard-bss"]) {
        await this.getStats();
        await this.getUsers();
        await this.getShops();
        await this.getVariants();
      }

      setTimeout(() => {
        this.$loading(false);
      }, 1000);
    },
    getStats() {
      this.done["stats"] = false;
      this.$http
        .get(`dashboard/subscription/stats`, {
          params: this.params,
        })
        .then((response) => {
          this.stats = response.data.data;
          this.device = response.data.device;

          this.subscriptionStatusChart["data"]["series"] = [
            response.data.device.control_percent,
            response.data.device.blocked_percent,
          ];
          this.subscriptionStatusChart["data"]["labels"] = [
            `${response.data.device.control_percent}%`,
            `${response.data.device.blocked_percent}%`,
          ];
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.done["stats"] = true;
        });
    },
    getUsers() {
      this.done["users"] = false;
      this.$http
        .get(`dashboard/subscription/users`, {
          params: this.params,
        })
        .then((response) => {
          this.users = response.data.data;

          try {
            this.users_low = response.data.data_low;
          } catch (error) {}
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.done["users"] = true;
        });
    },
    getShops() {
      this.done["shops"] = false;
      this.$http
        .get(`dashboard/subscription/shops`, {
          params: this.params,
        })
        .then((response) => {
          this.shops = response.data.data;

          try {
            this.shops_low = response.data.data_low;
          } catch (error) {}
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.done["shops"] = true;
        });
    },
    getVariants() {
      this.done["variants"] = false;
      this.$http
        .get(`dashboard/subscription/variants`, {
          params: this.params,
        })
        .then((response) => {
          this.variants = response.data.data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.done["variants"] = true;
        });
    },
  },
  data() {
    return {
      //filters

      subscriptionStatusChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {},
      },

      exportType: "",
      exportFields: {
        all: {
          "Номер заявки": {
            field: "id",
            callback: (value) => {
              return value;
            },
          },

          "Статус контроля": {
            field: "state_display",
            callback: (value) => {
              return value;
            },
          },
          // "Статус блокировки": {
          //   field: "subscription_status.status",
          //   callback: (value) => {
          //     return value;
          //   },
          // },
          "Дата установки статуса блокировки": {
            field: "subscription_status.time",
            callback: (value) => {
              return value;
            },
          },

          "Дата заявки": {
            field: "start_date",
            callback: (value) => {
              return value;
            },
          },
          "Дата окончания": {
            field: "end_date",
            callback: (value) => {
              return value;
            },
          },
          "Полное имя покупателя": {
            field: "user_fullname",
            callback: (value) => {
              return value;
            },
          },
          Пол: {
            field: "user_gender",
            callback: (value) => {
              return value ? "Мужской" : "Женский";
            },
          },
          "Полное имя оператора": {
            field: "user",
            callback: (value) => {
              return value.name;
            },
          },
          "Офис продаж": {
            field: "shop",
            callback: (value) => {
              return value.name;
            },
          },
          "Номер паспорта": {
            field: "user_passport",
            callback: (value) => {
              return value;
            },
          },
          "Контактный номер": {
            field: "user_phone",
            callback: (value) => {
              return value;
            },
          },
          ПИНФЛ: {
            field: "user_pinfl",
            callback: (value) => {
              return value;
            },
          },
          ПИНФЛ: {
            field: "user_pinfl",
            callback: (value) => {
              return value;
            },
          },
          "Абонентский номер": {
            field: "phone_control",
            callback: (value) => {
              return value;
            },
          },
          "Модель девайса": {
            field: "product_name",
            callback: (value) => {
              return value;
            },
          },
          "Баркод девайса": {
            field: "product_barcode",
            callback: (value) => {
              return value;
            },
          },
          "Баркод девайса": {
            field: "product_barcode",
            callback: (value) => {
              return value;
            },
          },
          "Срок действия договора": {
            field: "loan_period",
            callback: (value) => {
              return value;
            },
          },
          "Итоговая сумма": {
            field: "product_price",
            callback: (value) => {
              return value;
            },
          },
          "Итоговая сумма": {
            field: "product_price",
            callback: (value) => {
              return value;
            },
          },
          Статус: {
            field: "status",
            callback: (value) => {
              return value.name;
            },
          },
          "ИМЕИ 1": {
            field: "imeis",
            callback: (value) => {
              try {
                return value[0].number;
              } catch (error) {}
            },
          },
          "ИМЕИ 1 (СТАТУС)": {
            field: "imeis",
            callback: (value) => {
              try {
                return value[0].status;
              } catch (error) {}
            },
          },
          "ИМЕИ 2": {
            field: "imeis",
            callback: (value) => {
              try {
                return value[1].number;
              } catch (error) {}
            },
          },
          "ИМЕИ 2 (СТАТУС)": {
            field: "imeis",
            callback: (value) => {
              try {
                return value[1].status;
              } catch (error) {}
            },
          },

          "Номер полиса": {
            field: "insurance_polis_number",
            callback: (value) => {
              return `USI-${value}`;
            },
          },
          "Награда страховки": {
            field: "insurance_premium",
            callback: (value) => {
              return value;
            },
          },
          "Сумма компенсации": {
            field: "insurance_amount",
            callback: (value) => {
              return value;
            },
          },
          "Основной лимит": {
            field: "limit",
            callback: (value) => {
              return value;
            },
          },
          "Маркетинговый лимит": {
            field: "limit_preview",
            callback: (value) => {
              return value;
            },
          },
        },
        insurance: {
          "Статус контроля": {
            field: "state_display",
            callback: (value) => {
              return value;
            },
          },
          "№": {
            field: "id",
            callback: (value) => {
              return value;
            },
          },

          "Дата заключения договора": {
            field: "start_date",
            callback: (value) => {
              return value;
            },
          },

          "Полис №": {
            field: "insurance_polis_number",
            callback: (value) => {
              return `USI-${value}`;
            },
          },

          "Наименование Заемщика": {
            field: "user_fullname",
            callback: (value) => {
              return value;
            },
          },

          "Период страхование (дата окончание)": {
            field: "end_date",
            callback: (value) => {
              return value;
            },
          },

          "Страховая сумма": {
            field: "insurance_amount",
            callback: (value) => {
              return value;
            },
          },
          " Страховая премия": {
            field: "insurance_premium",
            callback: (value) => {
              return value;
            },
          },

          "Дата поступления премии": {
            field: "id",
            callback: (value) => {
              return "";
            },
          },
          "Агентское вознаграждение сум": {
            field: "id",
            callback: (value) => {
              return "";
            },
          },
        },

        imei: {
          "Статус контроля": {
            field: "state_display",
            callback: (value) => {
              return value;
            },
          },
          "№ Договора": {
            field: "id",
            callback: (value) => {
              return value;
            },
          },

          "Дата договора": {
            field: "start_date",
            callback: (value) => {
              return value;
            },
          },

          "Ф.И.О. клиента": {
            field: "user_fullname",
            callback: (value) => {
              return value;
            },
          },

          "Ф.И.О. работника": {
            field: "user.name",
            callback: (value) => {
              return value;
            },
          },
          Отделение: {
            field: "shop.name",
            callback: (value) => {
              return value;
            },
          },

          Регион: {
            field: "shop.location",
            callback: (value) => {
              return value ? value.title : "";
            },
          },
          "Паспортные данные клиента": {
            field: "user_passport",
            callback: (value) => {
              return value;
            },
          },
          ПИНФЛ: {
            field: "user_pinfl",
            callback: (value) => {
              return value;
            },
          },
          "Абонентский номер": {
            field: "phone_control",
            callback: (value) => {
              return value;
            },
          },
          "Модель девайса": {
            field: "product_name",
            callback: (value) => {
              return value;
            },
          },

          "ИМЕИ 1": {
            field: "imeis",
            callback: (value) => {
              try {
                return value[0].number;
              } catch (error) {}
            },
          },
          "ИМЕИ 1 (СТАТУС)": {
            field: "imeis",
            callback: (value) => {
              try {
                return value[0].status;
              } catch (error) {}
            },
          },
          "ИМЕИ 2": {
            field: "imeis",
            callback: (value) => {
              try {
                return value[1].number;
              } catch (error) {}
            },
          },
          "ИМЕИ 2 (СТАТУС)": {
            field: "imeis",
            callback: (value) => {
              try {
                return value[1].status;
              } catch (error) {}
            },
          },

          "Срок действия договора": {
            field: "loan_period",
            callback: (value) => {
              return value;
            },
          },

          "Сумма, сум": {
            field: "product_price",
            callback: (value) => {
              return value;
            },
          },
        },
      },

      device: {
        control: 0,
        blocked: 0,
      },

      timer: 180,

      typePeriods: [
        {
          value: "today",
          name: "За сегодня",
        },
        {
          value: "yesterday",
          name: "За вчера",
        },
        {
          value: "week",
          name: "За текущую неделю",
        },
        {
          value: "month",
          name: "За текущий месяц",
        },
        {
          value: "year",
          name: "За год",
        },
        {
          value: "",
          name: "Установить дату",
        },
      ],

      dateFilter: [
        {
          key: "from_at",
          titleKey: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          titleKey: "till_at",
          title: "Конец даты",
        },
      ],

      stats: [],
      users: [],
      users_low: [],
      shops: [],
      shops_low: [],
      variants: [],

      params: {
        period: "today",
      },

      done: {
        stats: false,
        users: false,
        shops: false,
        variants: false,
      },
    };
  },
  computed: {
    ...mapState(["user", "lastUpdate"]),
  },
  watch: {
    params: {
      handler: async function (val) {
        this.loadData();
      },
      deep: true,
    },
    timer(val) {
      if (val <= 0) {
        this.loadData(false);
        this.timer = 180;
      }
    },
  },
};
</script>

<style lang="scss">
.ratings {
  & h5 {
    color: #2c75ff;
    font-weight: 600;
    font-size: 1.4em;
    min-height: 40px;
  }
  & ul {
    & > li {
      padding: 6px 0;
      // display: flex;
      & > span {
        line-height: 18px;
        font-size: 14px;
        display: block;

        &:first-child {
          font-weight: 500;
          margin-bottom: 1px;
        }

        &:last-child {
          color: #e61d73;
        }
      }
    }
  }
}

.filters {
  display: flex;
  background: #fff;
  padding: 20px 20px 15px;
  border-radius: 20px;
}
</style>
